import React from "react";
import classNames from "classnames/bind";
import styles from "./InquiryDetail.module.scss";

const cx = classNames.bind(styles);

export default function InquiryDetail({ data }) {
  return (
    <>
      <div className={cx("inner")}>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>회사명</p>
            <p className={cx("text")}>{data?.company || "-"}</p>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>부서명</p>
            <p className={cx("text")}>{data?.department || "-"}</p>
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>직책</p>
            <p className={cx("text")}>{data?.position || "-"}</p>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>이름</p>
            <p className={cx("text")}>{data?.name || "-"}</p>
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>이메일</p>
            <p className={cx("text")}>{data?.email || "-"}</p>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>전화번호</p>
            <p className={cx("text")}>{data?.phone || "-"}</p>
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>문의 내용</p>
            <p className={cx("text")}>{data?.request_reason || "-"}</p>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>제품명</p>
            <p className={cx("text")}>{`${data?.document_name}` || "-"}</p>
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>개인정보처리방침 동의</p>
            <p className={cx("text")}>
              {data?.privacy_agree === 1 ? "동의" : "미동의"}
            </p>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>이메일 수집 거부</p>
            <p className={cx("text")}>
              {data?.email_reject === 1 ? "동의" : "미동의"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
